import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required!"),
  is_active: Yup.string().required("Status is required!"),
});
